module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "wrapper"
  }, [(!_vm.$route.meta.hidden || _vm.$route.name === 'reset') ? [(_vm.$auth.ready()) ? [_c('header', {
    staticClass: "header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    style: ({
      height: '32px !important'
    }),
    attrs: {
      "alt": "YIMIAN",
      "src": require("./assets/logo-yimian-white.png"),
      "height": "32"
    }
  })]), _vm._v(" "), _c('el-row', {
    staticClass: "user-info"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "avatar"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$auth.user().username))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "db-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.resetPassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-user-tie el-icon--left"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.resetPassword')) + "\n              ")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-exit el-icon--left"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.logout')) + "\n              ")]), _vm._v(" "), (!_vm.$auth.user().thirdparty_users.weixin) ? _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.loginByWeixin($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-exit el-icon--left"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.bound_weixin')) + "\n              ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container"
  }, [_c('aside', {
    staticClass: "menu-wrapper"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical",
    attrs: {
      "default-active": _vm.activeMenu,
      "theme": "dark",
      "router": "",
      "unique-opened": ""
    }
  }, [_vm._l((_vm.$router.options.routes[1].children), function(route, index) {
    return [(!route.meta.hidden && _vm.roleShow(route)) ? _c('el-menu-item', {
      class: {
        'is-active': route.name === _vm.activeMenu || route.name === 'applications' && _vm.$route.name === 'app_manage'
      },
      attrs: {
        "index": route.name,
        "route": route
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(("menu." + (route.name)))) + "\n              ")]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)] : _vm._e()] : _c('router-view')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea033354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 399
// module chunks = 1